import FJModal from '../FJModal/index.jsx';
import { useDispatch, useSelector } from 'react-redux';
import FJMediaLibraryInfoView from './FJMediaLibraryInfoView.jsx';
import { setMediaLibraryInfo } from '../../../redux/slices/FJSliceModals.js';
import FJKeymap from '../../../util/FJKeymap.js';
import { useEffect } from 'react';

const FJAddMediaLibraryInfoModalContainer = () => {
    const dispatch = useDispatch();

    const addMediaLibraryInfo = useSelector(state => state.modals.addMediaLibraryInfo);
    const { visible, list = [] } = addMediaLibraryInfo;

    useEffect(() => {
        FJKeymap.setScope(visible ? 'modal' : 'default');
    }, [visible]);

    const _onClose = () => {
        dispatch(setMediaLibraryInfo({ visible: false }));
    };

    return (
        <FJModal visible={visible} zIndex={9999}>
            <FJMediaLibraryInfoView list={list} onClose={_onClose} />
        </FJModal>
    );
};

export default FJAddMediaLibraryInfoModalContainer;
